import { PipesModule } from 'src/app/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { SliderOpComponent } from './slider-op.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [
    SliderOpComponent
  ],
  exports: [
    SliderOpComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    PipesModule
  ]
})
export class SliderOpModule { }
